import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "publish-storefront-events"
    }}>{`Publish storefront events`}</h1>
    <h2 {...{
      "id": "functions"
    }}>{`Functions`}</h2>
    <p>{`The following functions publish events to notify all subscribers.`}</p>
    <h3 {...{
      "id": "msepublishaddtocart"
    }}>{`mse.publish.addToCart`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`addToCart`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.addToCart(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishcustomurl"
    }}>{`mse.publish.customUrl`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`customUrl`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.customUrl(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishinitiatecheckout"
    }}>{`mse.publish.initiateCheckout`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`initiateCheckout`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.initiateCheckout(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishinstantpurchase"
    }}>{`mse.publish.instantPurchase`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`instantPurchase`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.instantPurchase(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishpageactivitysummary"
    }}>{`mse.publish.pageActivitySummary`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`pageActivitySummary`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.pageActivitySummary(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishpageview"
    }}>{`mse.publish.pageView`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`pageView`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.pageView(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishplaceorder"
    }}>{`mse.publish.placeOrder`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`placeOrder`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.placeOrder(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishproductpageview"
    }}>{`mse.publish.productPageView`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`productPageView`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.productPageView(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsitemaddtocartclick"
    }}>{`mse.publish.recsItemAddToCartClick`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsItemAddToCartClick`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommendations `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`productId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommended `}<inlineCode parentName="td">{`productId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsItemAddToCartClick(unitId, productId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsitemclick"
    }}>{`mse.publish.recsItemClick`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsItemClick`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommendations `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`productId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommended `}<inlineCode parentName="td">{`productId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsItemClick(unitId, productId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsrequestsent"
    }}>{`mse.publish.recsRequestSent`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsRequestSent`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsRequestSent(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsresponsereceived"
    }}>{`mse.publish.recsResponseReceived`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsResponseReceived`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsResponseReceived(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsunitrender"
    }}>{`mse.publish.recsUnitRender`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsUnitRender`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommendations `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsUnitRender(unitId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishrecsunitview"
    }}>{`mse.publish.recsUnitView`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`recsUnitView`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`unitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Recommendations `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.recsUnitView(unitId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishreferrerurl"
    }}>{`mse.publish.referrerUrl`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`referrerUrl`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.referrerUrl(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishremovefromcart"
    }}>{`mse.publish.removeFromCart`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`removeFromCart`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.removeFromCart(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchcategoryclick"
    }}>{`mse.publish.searchCategoryClick`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchCategoryClick`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Category name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchCategoryClick(searchUnitId, name, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchproductclick"
    }}>{`mse.publish.searchProductClick`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchProductClick`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`sku`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Product `}<inlineCode parentName="td">{`sku`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchProductClick(searchUnitId, sku, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchrequestsent"
    }}>{`mse.publish.searchRequestSent`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchRequestSent`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchRequestSent(searchUnitId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchresponsereceived"
    }}>{`mse.publish.searchResponseReceived`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchResponseReceived`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchResponseReceived(searchUnitId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchresultsview"
    }}>{`mse.publish.searchResultsView`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchResultsView`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchResultsView(searchUnitId, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsearchsuggestionclick"
    }}>{`mse.publish.searchSuggestionClick`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`searchSuggestionClick`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`searchUnitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes Search `}<inlineCode parentName="td">{`unitId`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`suggestion`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query `}<inlineCode parentName="td">{`suggestion`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.searchSuggestionClick(searchUnitId, suggestion, ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishshoppingcartview"
    }}>{`mse.publish.shoppingCartView`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`shoppingCartView`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.shoppingCartView(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsignin"
    }}>{`mse.publish.signIn`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`signIn`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.signIn(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishsignout"
    }}>{`mse.publish.signOut`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`signOut`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.signOut(ctx);
`}</code></pre>
    <h3 {...{
      "id": "msepublishupdatecart"
    }}>{`mse.publish.updateCart`}</h3>
    <p>{`Publishes the `}<inlineCode parentName="p">{`updateCart`}</inlineCode>{` event.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`context`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom context`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Syntax:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`mse.publish.updateCart(ctx);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      